/* eslint-disable indent */
export function formatCurrency(amount, currency = 'NGN') {
  const amountDefined = Number(amount) || 0;
  return amountDefined
    ? amountDefined
        .toLocaleString('en-NG', {
          style: 'currency',
          currency,
        })
        .slice(0, -3)
    : amountDefined;
}

export const parseStatus = (status = '') => (status ? 'active' : 'inactive');
export const parseTransactionStatus = (status = '') => (Number(status) ? 'Successful' : 'Pending');

export function formatMutiselectValue(item) {
  if (item) {
    return item?.value ?? item;
  }
  return;
}

export function formatThousand(value) {
  const num = Number(value);
  if (isNaN(num)) return value;

  // Format quadrillions for numbers >= 1 quadrillion (zillion scale)
  if (num >= 1000000000000000) {
    const quadrillions = num / 1000000000000000;
    return `${quadrillions.toFixed(quadrillions >= 10 ? 0 : 1)}Q`;
  }

  // Format trillions for numbers >= 1 trillion
  if (num >= 1000000000000) {
    const trillions = num / 1000000000000;
    return `${trillions.toFixed(trillions >= 10 ? 0 : 1)}T`;
  }

  // Format billions for numbers >= 1 billion
  if (num >= 1000000000) {
    const billions = num / 1000000000;
    return `${billions.toFixed(billions >= 10 ? 0 : 1)}B`;
  }

  // Format millions for numbers >= 100,000
  if (num >= 100000) {
    const millions = num / 1000000;
    return `${millions.toFixed(millions >= 10 ? 0 : 1)}M`;
  }

  // Regular thousand separator for numbers below 100k
  return num.toLocaleString('en-NG');
}

/**
 * Format a number for axis labels (Y-axis, etc.)
 * Formats with K, M, B, T, Q abbreviations starting from 1K
 * @param {number|string} value - The value to format
 * @returns {string} - Formatted string (e.g., "1.5K", "10M", "2.3B")
 */
export function formatAxisLabel(value) {
  const num = Number(value);
  if (isNaN(num)) return value;

  // Format quadrillions
  if (num >= 1000000000000000) {
    const q = num / 1000000000000000;
    return `${q >= 10 ? Math.round(q) : q.toFixed(1)}Q`;
  }
  // Format trillions
  if (num >= 1000000000000) {
    const t = num / 1000000000000;
    return `${t >= 10 ? Math.round(t) : t.toFixed(1)}T`;
  }
  // Format billions
  if (num >= 1000000000) {
    const b = num / 1000000000;
    return `${b >= 10 ? Math.round(b) : b.toFixed(1)}B`;
  }
  // Format millions
  if (num >= 1000000) {
    const m = num / 1000000;
    return `${m >= 10 ? Math.round(m) : m.toFixed(1)}M`;
  }
  // Format thousands
  if (num >= 1000) {
    const k = num / 1000;
    return `${k >= 10 ? Math.round(k) : k.toFixed(1)}K`;
  }
  return num.toString();
}
